import { render } from "./footer.vue?vue&type=template&id=2dfac08a&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=2dfac08a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2dfac08a"

export default script